// runtime-config singleton: expone la config cargada por plugins/runtime-config.js a
// código que NO está en el contexto Vue (p.ej. utils/services-enabled.js, rcp-08), donde
// `this.$config` no está disponible. El plugin llama setRuntimeConfig tras validar; los
// consumidores leen con getRuntimeConfig() de forma lazy (después del arranque).
let current = null;

export const setRuntimeConfig = (config) => {
  current = config;
};

export const getRuntimeConfig = () => current;
